export type CheckState = 'NEW' | 'LIMITED' | 'COMPLETED' | 'FAILED';

export const getCheckRefetchInterval = (check: { meta: { state: CheckState } } | null | undefined) => {
	if (check && (check.meta['state'] === 'NEW' || check.meta['state'] === 'LIMITED')) {
		return 2500;
	}
	return false;
};
